import React from 'react';
import { AutoComplete } from 'primereact/autocomplete';

const AutoCompleteBDI = props => {
    return React.createElement(
        React.Fragment,
        null,
        props.label ? React.createElement(
            'span',
            { className: 'p-float-label' },
            React.createElement(AutoComplete, {
                id: props.id,
                value: props.valor,
                onChange: props.acao,
                suggestions: props.sugestoes,
                completeMethod: props.metodocompleto,
                field: props.campo,
                disabled: props.disabled,
                autoFocus: props.autofocus
            }),
            React.createElement(
                'label',
                { htmlFor: 'autocomplete' },
                props.label
            )
        ) : React.createElement(AutoComplete, {
            id: props.id,
            value: props.valor,
            onChange: props.acao,
            suggestions: props.sugestoes,
            completeMethod: props.metodocompleto,
            field: props.campo,
            placeholder: props.placeholder,
            disabled: props.disabled,
            autoFocus: props.autofocus
        })
    );
};

export default AutoCompleteBDI;